import Vue from "vue";
import Buefy from "buefy";

import UserPanel from "./App.vue";

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(UserPanel)

if(document.getElementById("userPanelApp")){
    new Vue({
        render:h=>h(
            UserPanel,{
                props:{
                    profileUrl:document.getElementById("userPanelApp")
                        .getAttribute("profile-url"),
                    ordersUrl:document.getElementById("userPanelApp")
                        .getAttribute("orders-url"),
                    cartUrl:document.getElementById("userPanelApp")
                        .getAttribute("cart-url"),
                    passwordUrl:document.getElementById("userPanelApp")
                        .getAttribute("password-url")
                }
            }
        )
    }).$mount("#userPanelApp")
}